namespace RioERP.Orders {
    export interface TeacherPayoutForm {
        RowIds: Serenity.StringEditor;
        TeacherId: Serenity.LookupEditor;
        PaymentDate: Serenity.DateEditor;
        PaidAmount: Serenity.DecimalEditor;
        PaymentMode: Serenity.EnumEditor;
        Remark: Serenity.StringEditor;
        PaymentRefNo: Serenity.StringEditor;
        BankName: Serenity.StringEditor;
        Comment: Serenity.StringEditor;
        ReceiptNo: Serenity.StringEditor;
    }

    export class TeacherPayoutForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.TeacherPayout';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TeacherPayoutForm.init)  {
                TeacherPayoutForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.EnumEditor;

                Q.initFormType(TeacherPayoutForm, [
                    'RowIds', w0,
                    'TeacherId', w1,
                    'PaymentDate', w2,
                    'PaidAmount', w3,
                    'PaymentMode', w4,
                    'Remark', w0,
                    'PaymentRefNo', w0,
                    'BankName', w0,
                    'Comment', w0,
                    'ReceiptNo', w0
                ]);
            }
        }
    }
}
